import { accountsRoyaltyState } from "./accounts/state";
import { contractsRoyaltyState } from "./contracts/state";
import { dealsRoyaltyState } from "./deals/state";
import { recoupableState } from "./recoupable/state";
import { statementState } from './statement/state'
import { RoyaltyModulePluginStore } from "./plugin-store";

export const state = {
  ...accountsRoyaltyState,
  ...contractsRoyaltyState,
  ...dealsRoyaltyState,
  ...statementState,
  ...recoupableState,
  ...RoyaltyModulePluginStore.state
};
